import React from "react";

export default function Spinner({ color, sizeClass = "h-5 w-5" }) {
  const colorClass =
    color === "red"
      ? "text-red-500 dark:text-red-400"
      : "text-gray-500 dark:text-gray-400";

  return (
    <svg
      className={`animate-spin flex-shrink-0 ${sizeClass} ${colorClass}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
      role="img"
    >
      <circle
        className="opacity-75"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="80" // environ 1/4 de circonférence
        strokeDashoffset="60" // décalage initial de l’arc
      />
    </svg>
  );
}
